const dataFooter = {
  stringPrimary: 'str. 31 August, Drochia, Moldova',
};

export default dataFooter;
